// extracted by mini-css-extract-plugin
module.exports = {"tamara-wrapper":"TamaraPromo_tamara-wrapper__19CBR","custom-ui":"TamaraPromo_custom-ui__lveP6","tamara-promo-container":"TamaraPromo_tamara-promo-container___7Ly_"};